<template>
  <div class="termsofservice-view">
    <h1 class="agreement-title">服务条款</h1>
    <div class="agreement-content">
      <div class="agreement-content-text">
        <p>尊敬的用户您好，欢迎使用易软科技软件会员增值服务！</p>
        <p>为使用易软科技软件会员增值服务（简称为：本服务），您应当阅读《易软科技软件会员服务协议》（简称为：本协议）。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款。</p>
        <p>除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您对本服务的任何购买使用行为即视为您已阅读并同意本协议的约束。如果您未满18周岁，请在法定监护人的陪同下阅读本协议。</p>
        <p>本协议是用户与易软信息科技（惠州）有限公司（简称为：易软科技）之间关于用户加入成为易软科技软件会员且使用易软科技软件相关软件以及服务所订立的协议。本协议描述易软科技与会员之间关于软件许可以及服务使用及相关方面的权利义务。易软科技软件服务涉及到的易软科技产品的所有权以及相关软件的知识产权归易软科技所有。</p>
        <h3>【关于本服务】</h3>
        <p>会员增值服务费，指用户按照易软科技指定方式支付一定费用后，用户可以享有由易软科技软件提供的应用软件。易软科技可能会根据本服务的整体规划，对本服务的收费标准、增值服务内容进行修改和变更。</p>
        <h3>【用户禁止行为】</h3>
        <p>用户使用本服务的权利是个人的，不允许对账户进行出租、出售等，或其他利用账户进行牟利的行为，若有相关滥用行为，我方有权单方面暂停、禁止账户相关功能。</p>
        <h3>【退款声明】</h3>
        <p>为了避免购买本产品后引起纠纷，用户可在购买本服务前，对产品进行下载试用，看软件具体的使用效果，软件已提供免费试用，购买本服务则同意了易软科技VIP服务条款/已试用软件/认可软件，故本公司不接受用户退款申请。</p>
        <h3>【争议解决】</h3>
        <p>若您和易软科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交易软科技所在地法院管辖。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.termsofservice-view {
  width: 1200px;
  margin: 0 auto;
  min-height: 50vh;
  margin-top: 40px;
  margin-bottom: 80px;

  .agreement-title {
    text-align: center;
    text-wrap-mode: wrap;
    text-align: center;
    margin-top: 15px;
  }

  .agreement-content {
    text-wrap-mode: wrap;
    text-align: justify;

    p {
      font-size: 18px;
      line-height: 30px;
      margin-bottom: 18px;
      margin-top: 18px;
    }
  }
}

</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})
</script>

